export function createNoAccessPath({
  reason,
  action,
  returnUrl,
  basePath = '/no-access',
  query = {},
}) {
  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== null && value !== '') params.set(key, value)
  }

  if (reason) params.set('reason', reason)
  if (action) params.set('action', action)
  if (returnUrl) params.set('returnUrl', returnUrl)

  const queryString = params.toString()
  return queryString ? `${basePath}?${queryString}` : basePath
}

export function getSafeReturnUrl(value) {
  const returnUrl = Array.isArray(value) ? value[0] : value

  if (!returnUrl || typeof returnUrl !== 'string') return null
  if (!returnUrl.startsWith('/') || returnUrl.startsWith('//')) return null

  return returnUrl
}
